import { faCancel, faFilePdf } from '@fortawesome/pro-regular-svg-icons';
import IconToast from 'components/ui/IconToast';
import i18n from 'i18next';
import { useEffect } from 'react';
import { Id, toast } from 'react-toastify';
import { downloadFileUrl } from 'utils/downloadFile';
import { ExportWorkerMessage, WorkerInput, WorkerInputStart } from './export.worker';

let idIncrement = 0;
let worker: Worker;
const fileNames: Record<Id, string> = {};
const ExportPdfWorker = () => {
    useEffect(() => {
        worker = new Worker(new URL('./export.worker.ts', import.meta.url));

        worker.onmessage = (event: MessageEvent<ExportWorkerMessage>) => {
            const id = event.data.id;

            switch (event.data.type) {
                case 'progress':
                    const progress = event.data.payload;
                    if (progress < 100) toast.update(id, { progress: progress / 100 });
                    break;
                case 'result':
                    downloadFileUrl(event.data.payload, fileNames[id] + '.pdf', undefined, () => {});
                    toast.done(id);
                    break;
                case 'error':
                    toast.done(id);
                    const message = event.data.payload;
                    toast(() => <IconToast icon={faCancel} text={message} iconColor="error" />, {
                        autoClose: false,
                    });
                    break;
                case 'cancelled':
                    break;
            }
        };

        return () => {
            worker.terminate();
        };
    }, []);

    return <></>;
};

export default ExportPdfWorker;

function cancel(id: Id) {
    toast.done(id);
    toast(() => <IconToast icon={faCancel} text={i18n.t('cancelled')} />, { autoClose: 3000 });
    postMessage({ type: 'cancel', id });
}

export function startExport(message: Omit<WorkerInputStart, 'id' | 'type'>) {
    const id = ++idIncrement;
    toast(
        <IconToast
            icon={faFilePdf}
            text={i18n.t('browserExport')}
            action={{
                onClick: () => cancel(id),
                label: i18n.t('cancel'),
            }}
        />,
        {
            toastId: id,
            autoClose: false,
            closeOnClick: false,
            progress: 0,
            progressClassName: 'custom-progress',
            hideProgressBar: false,
        },
    );

    fileNames[id] = message.data.fileName ?? '';

    try {
        postMessage({ ...message, id, type: 'start' });
    } catch (error) {
        // No worker initiated.
        console.error('No worker');
    }
}

function postMessage(message: WorkerInput) {
    worker.postMessage(message);
}
